/**
 * Flag por tenant que enciende el GPS en las fotos (spec 2026-09-23, D13).
 *
 * La ubicación de la foto es también la ubicación del operario, y el art. 90
 * de la LOPDGDD exige informar a la plantilla ANTES de activarlo. Mientras el
 * flag no exista en el catálogo, está apagado.
 *
 * Vive en su propio módulo, sin dependencias, porque lo usan la cámara, el
 * guardián de permisos, el visor y los informes PDF.
 */
export const PHOTO_GEOTAG_FLAG = 'feature-photo-geotag';
